import { render, staticRenderFns } from "./auth-code-input.vue?vue&type=template&id=10616b45&scoped=true&"
import script from "./auth-code-input.vue?vue&type=script&lang=js&"
export * from "./auth-code-input.vue?vue&type=script&lang=js&"
import style0 from "./auth-code-input.vue?vue&type=style&index=0&id=10616b45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10616b45",
  null
  
)

export default component.exports